import { ConsentRecord } from './types'

/**
 * Placeholder for the future consent-audit backend.
 *
 * GDPR expects you to keep proof of consent; once the endpoint exists, POST the
 * record here (with the user id, if authenticated). For now this resolves
 * immediately so the UI never blocks on a network round-trip — the source of
 * truth stays in LocalStorage.
 *
 * Kept non-throwing on purpose: a failed audit sync must never prevent the user
 * from saving their choice locally.
 */
export async function persistConsentToBackend (record: ConsentRecord): Promise<void> {
  // TODO(api): replace with the real call, e.g.
  //   await fetch('/api/v1/consent', {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify(record),
  //   })
  try {
    console.debug('[consent] backend sync pending — stored locally:', record)
  } catch {
    /* console may be unavailable; ignore */
  }
}
